import { resolveEnv } from './runtime-config';

export const env = resolveEnv(
    window.__CONFIG__,
    {
        VITE_MODE: import.meta.env.VITE_MODE,
        VITE_REALM: import.meta.env.VITE_REALM,
        VITE_AGS_URL: import.meta.env.VITE_AGS_URL,
        VITE_HUB_URL: import.meta.env.VITE_HUB_URL,
        VITE_OSS_URL: import.meta.env.VITE_OSS_URL,
        VITE_TRAINING_URL: import.meta.env.VITE_TRAINING_URL,
        VITE_KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL,
        VITE_CUSTOMER_CONTROL_URL: import.meta.env.VITE_CUSTOMER_CONTROL_URL,
        VITE_BASE_URL_PATH: import.meta.env.VITE_BASE_URL_PATH,
        VITE_RAYGUN_API_KEY: import.meta.env.VITE_RAYGUN_API_KEY,
    },
    window.location.origin,
);

export const isProduction = env.VITE_MODE === 'production';
